"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBox = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
/**
 * A full-width, centerable Message box. Good for displaying error screens and messages.
 */
const MessageBox = ({ image, title, description, children, extra, className, fullHeight = true, }) => (react_1.default.createElement(core_1.Grid, { container: true, className: clsx_1.default('w-100%', className, { 'h-100%': fullHeight }), justify: "center" },
    react_1.default.createElement(core_1.Grid, { className: "max-w-12", container: true, item: true, direction: "column", justify: "center", alignItems: "center" },
        image && (react_1.default.createElement(core_1.Grid, { item: true, className: "pb-3" }, image)),
        title && (react_1.default.createElement(core_1.Grid, { item: true }, react_1.isValidElement(title) ? (title) : (react_1.default.createElement(core_1.Typography, { variant: "h1", gutterBottom: true }, title)))),
        description && (react_1.default.createElement(core_1.Grid, { item: true }, react_1.isValidElement(description) ? (description) : (react_1.default.createElement(core_1.Typography, { variant: "h4", gutterBottom: true }, description)))),
        children && react_1.default.createElement(core_1.Grid, { item: true }, children),
        extra && react_1.default.createElement(core_1.Grid, { item: true }, extra))));
exports.MessageBox = MessageBox;
exports.default = exports.MessageBox;
